import { useEffect } from 'react';

export const useOffcanvasReset = (offcanvasId, resetCallback) => {
  useEffect(() => {
    const offcanvasEl = document.getElementById(offcanvasId);

    if (!offcanvasEl) return;

    const handleOffcanvasHide = () => {
      resetCallback?.(); // Optional chaining for safety
    };

    offcanvasEl.addEventListener('hidden.bs.offcanvas', handleOffcanvasHide);

    return () => {
      offcanvasEl.removeEventListener('hidden.bs.offcanvas', handleOffcanvasHide);
    };
  }, [offcanvasId, resetCallback]); // Make sure these are included in deps
};
